/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './developpementWeb.css';
import Helmet from 'react-helmet';
import fetch from '../../core/fetch';
import { Link } from 'react-router';

const title = 'Développement Web';

@withStyles(s)
export default class DeveloppementWeb extends Component {
    
	constructor(props) {
        super(props);

        this.state = {
            developpementWeb: [],
            loader: true,
        };
    }

    componentDidMount(){

        this.GetDeveloppementWeb();

    }

    async GetDeveloppementWeb(){
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{developpementWeb{id, slug, title, content, titreBanniere, schema, schemaLeft, schemaRight, sectionPourquoi, sectionServices}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.developpementWeb) throw new Error('Erreur sur le chargement de la page développement web !');

        if(data){
            this.setState({ loader: false })
        }
        
        this.setState({ developpementWeb: data.developpementWeb })
    }

    render(){

        const topLink = <div className={`topLink`}>
                           <div className={`container`}>
                              <div className={`autreServices`}>
                                 <span>Nos autres services:</span>
                                 <ul>
                                    <li><Link to="/service-conseil">Accompagnement</Link></li>
                                    <li><Link to="/strategie-web">Stratégie Web</Link></li>
                                 </ul>
                              </div>
                           </div>
                        </div>;

        const titreBanniere = <div dangerouslySetInnerHTML={{ __html: this.state.developpementWeb.titreBanniere }} />;
        const topContent = <div dangerouslySetInnerHTML={{ __html: this.state.developpementWeb.content }} />;
        const schemaLeft = <div dangerouslySetInnerHTML={{ __html: this.state.developpementWeb.schemaLeft }} />;
        const schemaRight = <div dangerouslySetInnerHTML={{ __html: this.state.developpementWeb.schemaRight }} />;
        const sectionPourquoi = <div dangerouslySetInnerHTML={{ __html: this.state.developpementWeb.sectionPourquoi }} />;
        const sectionServices = <div dangerouslySetInnerHTML={{ __html: this.state.developpementWeb.sectionServices }} />;
        
        const appear = this.state.loader ? 'appear' : '';

        var background = {
            backgroundColor: '#00bf43'
        }

        return (
	        <div className={s.root}>
	            <Helmet title={title} meta={[{"name": "description", "content": "Stratégie Web, Planification Stratégique, Programmation et intégration web, Design Graphique, Assurance Qualité"}]}/>
                <div className={`spinner ${appear}`} style={background}></div>
	            <div id="developpementWeb" className={`developpementWeb`}>
                    <div className={`bgExpertise`}>
                        <div className={`container`}>
                            <div className={`content`}>
                                <h1 className={`titrePage`}>{titreBanniere}</h1>
                            </div>
                        </div>
                    </div>
                    <main role="main">
                        {topLink}
                        {topContent}
                        <div className={`sectionSchema`}>
                            <div className={`wrapSchema`}>
                                <div className={`container`}>
                                    <div className={`leftCol`}>
                                        <div className={`content`}>
                                            {schemaLeft}
                                        </div>
                                    </div>
                                    <div className={`centerCol`}>
                                        <div className={`imageSchema`}></div>
                                    </div>
                                    <div className={`rightCol`}>
                                        <div className={`content`}>
                                            {schemaRight}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`sectionPourquoi`}>
                            <span className={`smallTitle`}>Pourquoi choisir</span>
                            <h1 className={`titrePage`}>Prolifik ?</h1>
                            <div className={`circleLine`}>
                                <div className={`circle`}></div>
                                <div className={`line`}></div>
                                <div className={`circle`}></div>
                                <div className={`line`}></div>
                                <div className={`circle`}></div>
                                <div className={`line`}></div>
                                <div className={`circle`}></div>
                            </div>
                            <div className={`pourquoiListe`}>
                                <div className={`container`}>
                                    {sectionPourquoi}
                                </div>
                            </div>
                        </div>
                        <div className={`sectionServices`}>
                            <div className={`container`}>
                                <span className={`smallTitle`}>Nos</span>
                                <h1 className={`titrePage`}>Services</h1>
                                <div className={`wrapServices`}>
                                    {sectionServices}
                                </div>
                            </div> 
                        </div>
                        <div className={`container`}>
                            <div className={`bottomContact`}>
                                <div className={`w50`}>
                                    <span className={`smallTitle`}>Vous désirez</span>
                                    <h1 className={`titrePage`}>Faire des ventes</h1>
                                    <span className={`smallTitle`}>grâce au web</span>
                                </div>
                                <div className={`w50`}>
                                    <div className={`btnSite`}>
                                        <Link to="/contact">Contactez-nous dès maintenant!</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
	    );
    }
}









// WEBPACK FOOTER //
// ./containers/developpementWeb/developpementWeb.js